import { render } from "./Alert.vue?vue&type=template&id=c4c20836&scoped=true"
import script from "./Alert.vue?vue&type=script&lang=js"
export * from "./Alert.vue?vue&type=script&lang=js"

import "./Alert.vue?vue&type=style&index=0&id=c4c20836&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4c20836"]])

export default __exports__